import script from "./EmployeeDocumentForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmployeeDocumentForm.vue?vue&type=script&lang=ts&setup=true"

import "./EmployeeDocumentForm.vue?vue&type=style&index=0&id=558aeae0&lang=scss"

const __exports__ = script;

export default __exports__